<template>
    <div class="land-street">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.street_section_title_img + ')'"></div>
            <h2 v-html="salesCard.street_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-street-column-container">
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img" v-if="salesCard.street_carousel_init != null && salesCard.street_carousel_init == 'false'">
                        <img :src="salesCard.street_img" alt="">
                    </div>
                    <div class="col-carousel" v-if="salesCard.street_carousel_init != null && salesCard.street_carousel_init == 'true'">
                        <div class="street-gallery" :class="{'nav-init' : salesCard.street_img_carousel != undefined && salesCard.street_img_carousel.length > 1}">
                            <swiper :options="swiperOption" ref="landStreetGallery">
                                <swiper-slide v-for="(slide, index) in salesCard.street_img_carousel" :key="index">
                                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="swiper-controls sales-land-controls sales-land-street-controls" v-if="salesCard.street_img_carousel != undefined && salesCard.street_img_carousel.length > 1">
                            <div class="sales-land-btn-prev sales-land-street-btn-prev slider-btn">
                                <svgIcon name="left-arrow" />
                            </div>
                            <div class="sales-land-btn-next sales-land-street-btn-next slider-btn">
                                <svgIcon name="right-arrow" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2 v-html="salesCard.street_section_title"></h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.street_desc"></div>
                    <div class="desc-icons-list list-six" :class="'desc-icons-' + projectNameG">
                        <ul>
                            <li v-for="(item, index) in salesCard.street_icon_list" :key="index">
                                <div class="icon-img">
                                    <img :src="item.icon" alt="">
                                </div>
                                <div class="icon-desc">
                                    <p v-html="item.desc"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-land-street',
        components: {
            svgIcon,
        },
        data () {
            return {
                projectNameG: window.host,
                swiperOption: {
                    effect: 'coverflow',
                    centeredSlides: true,
                    slidesPerView: "auto",
                    initialSlide: 1,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 300,
                        modifier: 0.4,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: '.sales-land-street-btn-next',
                        prevEl: '.sales-land-street-btn-prev',
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-street.scss';
    @import '@/styles/components/sales/respond/land-street-respond.scss';
</style>